/**
 * Toplu atamada üye seçimi (mobil memberSelection.ts ile aynı). Üye:
 * { id, name, surname }.
 */
const norm = (value) => String(value || "").toLocaleLowerCase("tr-TR").replace(/\s+/g, " ").trim();

export const memberName = (m) => `${m?.name ?? ""} ${m?.surname ?? ""}`.trim();

/** Ada ve soyada göre arama; Türkçe büyük/küçük harf (İ/i, I/ı) doğru eşleşir. */
export function filterMembers(members, query) {
  const q = norm(query);
  if (!q) return members;
  return members.filter((m) => norm(memberName(m)).includes(q));
}

export function toggleMember(selected, id) {
  return selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id];
}

export function allVisibleSelected(visible, selected) {
  if (visible.length === 0) return false;
  const chosen = new Set(selected);
  return visible.every((m) => chosen.has(m.id));
}

/** "Tümünü seç / kaldır" yalnız aramada görünenlere uygulanır. */
export function toggleAllVisible(visible, selected) {
  const ids = new Set(visible.map((m) => m.id));
  if (allVisibleSelected(visible, selected)) return selected.filter((id) => !ids.has(id));
  const chosen = new Set(selected);
  return [...selected, ...Array.from(ids).filter((id) => !chosen.has(id))];
}

/** Açılışta grubun bütün üyeleri seçili gelir. */
export function initialSelection(members) {
  return Array.from(new Set(members.map((m) => String(m.id))));
}

/** Grup verisindeki üyeler seçilebilir biçime (kimlik metin). */
export function toSelectable(members) {
  return (members || []).map((m) => ({ id: String(m.id), name: m.name, surname: m.surname }));
}
